import { isSet } from "../utils/isSet";
import EmblaCarousel from 'embla-carousel';
import { addPrevNextBtnsClickHandlers } from './emblaCarouselControls';

function initEmblaCarousels(){
    function initOperationsProcessCarousel(){
        const operationsProcessCarouselNodes = document.querySelectorAll('.block--operations-process .embla--js');
        if(!isSet(operationsProcessCarouselNodes)) return;

        operationsProcessCarouselNodes.forEach((operationsProcessCarouselNode) => {
            const operationsProcessViewportNode = operationsProcessCarouselNode.querySelector('.embla__viewport');
            if(!isSet(operationsProcessViewportNode)) return;

            const operationsProcessSlideNodes = operationsProcessViewportNode.querySelectorAll('.embla__slide');
            if(!isSet(operationsProcessSlideNodes) || operationsProcessSlideNodes.length === 0) return;

            const prevBtnNodes = operationsProcessCarouselNode.querySelectorAll('.embla__button--prev');
            const nextBtnNodes = operationsProcessCarouselNode.querySelectorAll('.embla__button--next');
    
            const operationsProcessEmblaOptions = {
                loop: false,
                dragFree: true,
                align: 'start'
            }
    
            const operationsProcessEmblaApi = EmblaCarousel(
                operationsProcessViewportNode, 
                operationsProcessEmblaOptions,
                []
            );

            if(isSet(prevBtnNodes) && isSet(nextBtnNodes)){
                const removeOperationsProcessCarouselPrevNextClickHandlers = addPrevNextBtnsClickHandlers(
                    operationsProcessEmblaApi,
                    prevBtnNodes,
                    nextBtnNodes
                );

                operationsProcessEmblaApi.on('destroy', removeOperationsProcessCarouselPrevNextClickHandlers);
            }

            const toggleActiveWhenScrollable = () => {
                const isScrollable = operationsProcessEmblaApi.internalEngine().scrollSnaps.length > 1
                operationsProcessEmblaApi.reInit({ watchDrag: isScrollable });
                if(isScrollable){
                    operationsProcessCarouselNode.classList.add('is-active');
                    operationsProcessCarouselNode.classList.remove('is-disabled');
                } else{
                    operationsProcessCarouselNode.classList.add('is-disabled');
                    operationsProcessCarouselNode.classList.remove('is-active');
                }
            }

            operationsProcessEmblaApi
                .on('resize', toggleActiveWhenScrollable)

            toggleActiveWhenScrollable();
        });
    }
    initOperationsProcessCarousel();
}
export { initEmblaCarousels };